import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUnpublishTierMutation = createMutationHook(
  MembershipsCreatorApiClient.unpublishTier,
  {
    mutationKey: ['unpublishTier'],
  },
)
